import { render } from "./FullReportTable.vue?vue&type=template&id=20e8a27d&scoped=true"
import script from "./FullReportTable.vue?vue&type=script&lang=js"
export * from "./FullReportTable.vue?vue&type=script&lang=js"

import "./FullReportTable.vue?vue&type=style&index=0&id=20e8a27d&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e8a27d"]])

export default __exports__